import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import CModal from '@/components/CModal.vue';
import CButton from '@/components/shared/CButton';
import CLoader from '@/components/shared/CLoader.vue';
import { getStylePresets, resolveThumbnailUrl } from '../../core/presets';
import defaultThumbnail from '@/assets/images/crossword-default-thumb.png';
import type { CrosswordStyleDraft } from '../../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'CrosswordStyleSelectModal',
  props: {
    value: { type: Boolean },
    addedPresetIds: null
  },
  emits: ["input", "select", "create-custom"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: boolean): void;
    (event: 'select', value: CrosswordStyleDraft): void;
    (event: 'create-custom'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    value: boolean;
    addedPresetIds?: string[];
};





const presets = ref<CrosswordStyleDraft[]>([]);
const loading = ref(false);

const loadPresets = async () => {
    if (presets.value.length || loading.value) return;

    loading.value = true;
    try {
        presets.value = await getStylePresets();
    } finally {
        loading.value = false;
    }
};

const thumbnailUrl = (preset: CrosswordStyleDraft) => resolveThumbnailUrl(preset) || defaultThumbnail;

const isAdded = (preset: CrosswordStyleDraft) => !!props.addedPresetIds?.includes(preset.presetId || '');

const handleSelect = (preset: CrosswordStyleDraft) => {
    if (isAdded(preset)) return;
    emit('select', preset);
};

watch(
    () => props.value,
    (isOpen) => {
        if (isOpen) loadPresets();
    },
    { immediate: true }
);

return { __sfc: true,props, emit, presets, loading, loadPresets, thumbnailUrl, isAdded, handleSelect, CModal, CButton, CLoader }
}

})